<template>
  <b-input-group>
    <b-form-timepicker
      v-model="internalValue"
      :disabled="disabled"
      v-bind="labels"
      right
      :locale="$i18n.locale"
      @input="handleInput"
    />
  </b-input-group>
</template>

<script>
export default {
  name: 'TimePicker',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  computed: {
    labels () {
      return {
        labelHours: this.$i18n.t('timePicker.labelHours'),
        labelMinutes: this.$i18n.t('timePicker.labelMinutes'),
        labelSeconds: this.$i18n.t('timePicker.labelSeconds'),
        labelIncrement: this.$i18n.t('timePicker.labelIncrement'),
        labelDecrement: this.$i18n.t('timePicker.labelDecrement'),
        labelSelected: this.$i18n.t('timePicker.labelSelected'),
        labelNoTimeSelected: this.$i18n.t('timePicker.labelNoTimeSelected'),
        labelCloseButton: this.$i18n.t('timePicker.labelCloseButton'),
      }
    }
  },
  methods: {
    handleInput(value) {
      !this.disabled && this.$emit('input', value)
    }
  }
}
</script>

